import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
//
// Components
//
import { VehicleDetailHeaderComponent } from './vehicle-detail-header.component';
import { SharedModule } from '../../shared.module';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        FlexLayoutModule,
        SharedModule
    ],
  declarations: [
    VehicleDetailHeaderComponent
  ],
  exports: [
    VehicleDetailHeaderComponent
  ]
})

export class VehicleDetailHeaderComponentModule {
}
